export const validateGroupName = (name: string) => {
  switch (name) {
    case 'mundoIds':
      return 'mundo'
    case 'mundoSelectIds':
      return 'mundo'
    case 'periodoIds':
      return 'periodo'
    case 'periodoSelectIds':
      return 'periodo'
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'
    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'
    case 'tipoCentroIds':
      return 'tipoCentro'
    case 'tipoCentroSelectIds':
      return 'tipoCentro'
    case 'pedidosIds':
      return 'pedidos'
    case 'pedidosSelectIds':
      return 'pedidos'

    case 'subCategoriaIds':
      return 'subCategoria'
    case 'subCategoriaSelectIds':
      return 'subCategoria'
    case 'fornecedorSelectIds':
      return 'fornecedor'
    case 'produtoSelectIds':
      return 'produto'
    default:
      return null
  }
}
